import React from 'react';
/*eslint-disable */
import AppleStoreBadge from './AppleStoreBadge.svg';

export default ({ ...props }) => <AppleStoreBadge data-testid="apple-store-badge" {...props} />;
